import ListPickerIcon from "../../assets/icons/ListPIckerIcon";
import React from "react";

interface NoSelectedConversationViewProps {
    toggleFullScreen: () => void;
    FullScreenIcon: () => JSX.Element;
}

const NoSelectedConversationView = ({ toggleFullScreen, FullScreenIcon }: NoSelectedConversationViewProps) => {
    return <div className="no-selected-conversation-view-container">
        <div className="full-screen-button-container" onClick={toggleFullScreen}><FullScreenIcon /></div>
        <ListPickerIcon width={350} color="#cacaca" />
        <div className="title">No conversation is selected</div>
        <div className="description">
            To start a conversation with your clients, select a conversation from the left side of the screen. Learn more.
        </div>
    </div>
}

export default NoSelectedConversationView;